import { appsWebModule } from './apps';
import { aiWebModule } from './ai';
import { authWebModule } from './auth';
import { calendarWebModule } from './calendar';
import { checkinWebModule } from './checkin';
import { devWebModule } from './dev';
import { digestWebModule } from './digest';
import { gamesWebModule } from './games';
import { householdWebModule } from './household';
import { listsWebModule } from './lists';
import { recipesWebModule } from './recipes';
import { sharingWebModule } from './sharing';
import { trackersWebModule } from './trackers';
import { clearModules, registerModule } from './registry';

/**
 * The single place modules are wired into the client. Adding a module means adding one
 * line here plus its own directory — nothing else.
 */
export function registerCoreModules(): void {
  clearModules();
  registerModule(calendarWebModule);
  registerModule(listsWebModule);
  registerModule(recipesWebModule);
  registerModule(householdWebModule);
  registerModule(checkinWebModule);
  registerModule(digestWebModule);
  registerModule(authWebModule);
  registerModule(appsWebModule);
  // Games: its own tab since 2026-11-03.
  registerModule(gamesWebModule);
  // WS-15 foundation module: no nav, no routes — it publishes the audience UI + hooks
  // that lists/calendar (and WS-16's Apps tab) import.
  registerModule(sharingWebModule);
  // WS-18 foundation module: no nav, no routes, no docs — it publishes `useAiQuick` and
  // the /api/ai client for other modules (docs/AI-PIPELINE.md).
  registerModule(aiWebModule);
  // Trackers (2026-08-18): no nav and no routes — both its surfaces are embedded, in the
  // Apps tab and on the digest (see modules/trackers/index.ts). Registered for its docs.
  registerModule(trackersWebModule);
  // Work-schedule photo import: ARCHIVED 2026-11-03 (owner: "we might need it again").
  // Code stays in modules/workSchedule; to bring it back, register `workScheduleWebModule`
  // here and re-embed `WorkScheduleSection` (Apps) and `WorkScheduleShortcut` (digest).
  // TEMPORARY (WS-1): the /dev/sync scratch page. Remove with the dev module.
  registerModule(devWebModule);
}

export * from './registry';
